<template>
  <t-row>
    <t-column><a :href="url" target="_blank">{{ filename }}</a></t-column>
    <t-column>{{ fileType }}</t-column>
    <t-column>{{ fileSize }}</t-column>
    <t-column>{{ uploadDate }}</t-column>
  </t-row>
</template>

<script lang="ts">
  import Vue from "vue";
  import fileAttachmentMixin from "../mixins/fileAttachmentMixin";

  export default Vue.extend({
    mixins: [
      fileAttachmentMixin,
    ],
    props: {
      attachment: {
        type: Object,
        required: true
      }
    },
  });
</script>